export default "__VITE_ASSET__9d9fb913__"